import nativeApi from '@/utils/native-api'

function setNavigationBarColor(tintColor, tintColorStyle = '0', statusBarStyle = '0') {
  let params = {tintColor}

  if (tintColorStyle) {
    params.tintColorStyle = tintColorStyle
  }

  if (statusBarStyle) {
    params.statusBarStyle = statusBarStyle
  }

  nativeApi.invoke("setNavigationBarTintColor", params)
}

export default {
  methods: {
    setNavigationBarColor(color) {
      setTimeout(() => {
        try {
          //设置白色导航
          if (color == '255,255,255,1') {
            nativeApi.invoke('getDeviceInfo').then((result) => {
              if (result && result.version >= "6.2.2") {
                setNavigationBarColor(color, '1', '1')
              }
            })
          }
          else {
            setNavigationBarColor(color)
          }
        }
        catch (e) {
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/setNavigationBarColor.js